import { Action } from '@ngrx/store';
import { SimInfoResource, TechnicalError } from '@dch/products-business-logic';
import { SimInfoRequest } from '@dch/products-business-logic/src/pricing-plan/sim-info-resource.model';

export const GET_SIM_INFO = 'GET_SIM_INFO';
export const GET_SIM_INFO_SUCCESS = 'GET_SIM_INFO_SUCCESS';
export const GET_SIM_INFO_FAILED = 'GET_SIM_INFO_FAILED';

export class GetSimInfo implements Action {
  type = GET_SIM_INFO;

  constructor(public payload: SimInfoRequest) {}
}

export class GetSimInfoSuccess implements Action {
  type = GET_SIM_INFO_SUCCESS;

  constructor(public payload: SimInfoResource) {}
}

export class GetSimInfoFailed implements Action {
  type = GET_SIM_INFO_FAILED;

  constructor(public payload: TechnicalError) {}
}

export type Actions = GetSimInfo | GetSimInfoSuccess | GetSimInfoFailed;
